import {FullscreenPanel, FullscreenPanelBody} from '@yandex-delivery/blocks'
import {useElementSizes} from '@yandex-delivery/hooks'
import {memo, useMemo} from 'react'

import {defaultCoordinates} from '../../../../actions/AddDestination/useAddDestinationAction'
import {RouteInfo} from '../../../../widgets/RouteInfo/RouteInfo'
import {useRouteInfo} from '../../../../widgets/RouteInfo/useRouteInfo'
import {Map} from '../Map/Map'

/** Пропсы компонента RouteMap */
type RouteMapProps = {
  /** Действие при закрытии модалки */
  onClose: VoidFunction
}

/**
 * Фулскрин-модалка с маршрутом: карта с маршрутом и управление адресами маршрута в дровере.
 * При любом изменении данных маршрут меняется и в стейте.
 */
export const RouteMap = memo<RouteMapProps>(function RouteMap({onClose}) {
  const {routeInfoRef, addresses, handleSave, setAddresses} = useRouteInfo({
    onSave: onClose,
  })

  const {height: mapBottomOffset} = useElementSizes(routeInfoRef)

  // Точки, отображаемые на карте
  const routeCoordinates = useMemo(
    () =>
      addresses
        .map(({address}) => address.coordinates)
        .filter(
          coordinates =>
            Array.isArray(coordinates) &&
            (coordinates[0] !== defaultCoordinates[0] || coordinates[1] !== defaultCoordinates[1]),
        ),
    [addresses],
  )

  return (
    <FullscreenPanel anchor="bottom" opened>
      <FullscreenPanelBody>
        <Map bottomOffset={mapBottomOffset} onGoBack={onClose} route={routeCoordinates} />
        <RouteInfo
          ref={routeInfoRef}
          addresses={addresses}
          fullscreen={false}
          onSave={handleSave}
          setAddresses={setAddresses}
        />
      </FullscreenPanelBody>
    </FullscreenPanel>
  )
})
